import AuthenticationPage from "../pages/authentication/Index";

export default function Authentication() {
  return <AuthenticationPage />;
}
